import { render, staticRenderFns } from "./AnagraficaSearch.vue?vue&type=template&id=1f5419c4&"
import script from "./AnagraficaSearch.vue?vue&type=script&lang=ts&"
export * from "./AnagraficaSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports